const getSourceFromUrl  = (path) => {
  const arrData = path.split('/').filter((item) => item);

  return arrData.length > 0 ? arrData[0] : null;
};

export default getSourceFromUrl;
